import { __decorate, __metadata } from "tslib";
import { IsBoolean, Length } from 'class-validator';
/**
 * Configuration for specifying languages when ordering a transcript
 */
export class LanguagesConfiguration {
    /**
     * @param enabled Indicates whether languages can be specified when ordering a transcript
     * @param description The description to display above the languages field when ordering a transcript
     */
    constructor(enabled, description) {
        this.enabled = enabled;
        this.description = description;
    }
}
LanguagesConfiguration.MAX_DESCRIPTION_LENGTH = 200;
__decorate([
    IsBoolean(),
    __metadata("design:type", Boolean)
], LanguagesConfiguration.prototype, "enabled", void 0);
__decorate([
    Length(0, LanguagesConfiguration.MAX_DESCRIPTION_LENGTH),
    __metadata("design:type", String)
], LanguagesConfiguration.prototype, "description", void 0);
export const DEFAULT_LANGUAGES_CONFIGURATION = new LanguagesConfiguration(false, 'Please specify the languages that were used in court.');
